var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgC12(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-2"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 254.59,
    cy: 356.57,
    rx: 228.27,
    ry: 131.79,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadows--inject-2"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 220.85,
    cy: 311.14,
    rx: 46.74,
    ry: 26.99,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.18,388c25.13,14.51,25.13,38,0,52.54s-65.88,14.52-91,0-25.13-38,0-52.55S376.05,373.47,401.18,388Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.48,292.61l132,76.19a3.46,3.46,0,0,1,0,6l-77.88,45a10.61,10.61,0,0,1-10.62,0L78,343.56a3.45,3.45,0,0,1,0-6l77.89-45A10.59,10.59,0,0,1,166.48,292.61Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.61,349.3l91.48,54.39a2.18,2.18,0,0,1,0,3.76l-49,28.27a6.68,6.68,0,0,1-6.67,0L60,381.33a2.17,2.17,0,0,1,0-3.76l49-28.27A6.68,6.68,0,0,1,115.61,349.3Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.7,238.21l157,90.6a7.33,7.33,0,0,0,7.33,0l9.86-5.69a2.53,2.53,0,0,0,0-4.39L301,228.19a7.49,7.49,0,0,0-7.52,0l-9.76,5.63A2.53,2.53,0,0,0,283.7,238.21Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Tasks--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M295.29,233.61l152.56,88.08a3.59,3.59,0,0,0,5.39-3.1V117.65a9.79,9.79,0,0,0-4.89-8.46L302.58,25a4.86,4.86,0,0,0-7.29,4.21Z",
    style: {
      fill: "#D175F7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.29,233.61l152.56,88.08a3.59,3.59,0,0,0,5.39-3.1V117.65a9.79,9.79,0,0,0-4.89-8.46L302.58,25a4.86,4.86,0,0,0-7.29,4.21Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "299.61 242.84 439.5 323.6 439.5 119.41 299.61 38.65 299.61 242.84",
    style: {
      fill: "#D175F7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "299.61 242.84 439.5 323.6 439.5 119.41 299.61 38.65 299.61 242.84",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "285.95 226.53 425.84 307.29 439.5 119.41 299.61 38.65 285.95 226.53",
    style: {
      fill: "#D175F7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "285.95 226.53 425.84 307.29 439.5 119.41 299.61 38.65 285.95 226.53",
    style: {
      fill: "#fff",
      opacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "299.61 38.65 439.5 119.41 444.8 116.35 304.91 35.58 299.61 38.65",
    style: {
      fill: "#D175F7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "299.61 38.65 439.5 119.41 444.8 116.35 304.91 35.58 299.61 38.65",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "444.8 116.35 444.8 319.76 439.5 323.6 439.5 119.41 444.8 116.35",
    style: {
      fill: "#D175F7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "444.8 116.35 444.8 319.76 439.5 323.6 439.5 119.41 444.8 116.35",
    style: {
      fill: "#D175F7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "444.8 116.35 444.8 319.76 439.5 323.6 439.5 119.41 444.8 116.35",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401,145.91a1.5,1.5,0,0,1-.37,0,1.41,1.41,0,0,1-.94-.84l-4.16-10.45a1.41,1.41,0,0,1,.79-1.82,1.39,1.39,0,0,1,1.82.78l3.46,8.69,19.91-15.81a1.4,1.4,0,0,1,2,.22,1.42,1.42,0,0,1-.22,2l-21.39,17A1.39,1.39,0,0,1,401,145.91Z",
    style: {
      fill: "#D175F7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.75,123.38a1.46,1.46,0,0,1-.7-.18l-58.9-34a1.4,1.4,0,0,1,1.41-2.43l58.9,34a1.4,1.4,0,0,1-.71,2.62Z",
    style: {
      fill: "#D175F7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.4,135.47a1.37,1.37,0,0,1-.7-.19l-58.9-34a1.4,1.4,0,0,1,1.41-2.43l58.9,34a1.4,1.4,0,0,1-.71,2.62Z",
    style: {
      fill: "#D175F7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.39,161.22a3.7,3.7,0,0,1-1.82-.48l-18.21-10.07a7.75,7.75,0,0,1-4-7.43l1.73-20.31a3.77,3.77,0,0,1,5.62-2.93l19.15,11.06a5.65,5.65,0,0,1,2.79,5.26l-1.56,21.41a3.72,3.72,0,0,1-1.95,3A3.81,3.81,0,0,1,410.39,161.22Zm-18.51-38.91a.95.95,0,0,0-.95.86l-1.73,20.31a4.92,4.92,0,0,0,2.52,4.73l18.21,10.08a1,1,0,0,0,.91,0,.94.94,0,0,0,.49-.76l1.56-21.41a2.82,2.82,0,0,0-1.39-2.62h0l-19.16-11.06A.85.85,0,0,0,391.88,122.31Z",
    style: {
      fill: "#D175F7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.59,173.42a1.39,1.39,0,0,1-.7-.19l-58.9-34a1.4,1.4,0,0,1,1.41-2.43l58.9,34a1.4,1.4,0,0,1-.71,2.62Z",
    style: {
      fill: "#D175F7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.24,185.5a1.39,1.39,0,0,1-.7-.19l-58.9-34a1.4,1.4,0,0,1,1.41-2.43l58.9,34a1.4,1.4,0,0,1-.71,2.62Z",
    style: {
      fill: "#D175F7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.23,211.25a3.83,3.83,0,0,1-1.82-.47L386.2,200.7a7.74,7.74,0,0,1-4-7.43L384,173a3.76,3.76,0,0,1,5.62-2.93l19.15,11.06h0a5.63,5.63,0,0,1,2.79,5.25L410,207.77a3.76,3.76,0,0,1-3.74,3.48Zm-18.51-38.91a1,1,0,0,0-.44.11.93.93,0,0,0-.51.76L385,193.51a4.92,4.92,0,0,0,2.52,4.73l18.21,10.08a.91.91,0,0,0,.91,0,.9.9,0,0,0,.49-.76l1.56-21.41a2.82,2.82,0,0,0-1.39-2.62l-19.16-11.06A.85.85,0,0,0,387.72,172.34Z",
    style: {
      fill: "#D175F7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.37,195.48a1.57,1.57,0,0,1-.37,0,1.41,1.41,0,0,1-.94-.84l-4.16-10.44a1.4,1.4,0,0,1,2.61-1L398,191.8,417.88,176a1.41,1.41,0,0,1,1.75,2.2l-21.39,17A1.4,1.4,0,0,1,397.37,195.48Z",
    style: {
      fill: "#D175F7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.44,223.45a1.37,1.37,0,0,1-.7-.19l-58.91-34a1.41,1.41,0,0,1,1.41-2.44l58.9,34a1.4,1.4,0,0,1-.7,2.62Z",
    style: {
      fill: "#D175F7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.09,235.54a1.43,1.43,0,0,1-.71-.19l-58.9-34a1.4,1.4,0,1,1,1.41-2.43l58.9,34a1.41,1.41,0,0,1-.7,2.63Z",
    style: {
      fill: "#D175F7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.07,261.28a3.65,3.65,0,0,1-1.81-.47L382,250.73a7.75,7.75,0,0,1-4-7.43l1.74-20.3a3.72,3.72,0,0,1,2-3,3.76,3.76,0,0,1,3.61.08l19.15,11.06h0a5.64,5.64,0,0,1,2.78,5.26l-1.56,21.41a3.74,3.74,0,0,1-1.95,3A3.8,3.8,0,0,1,402.07,261.28Zm-18.51-38.9a1,1,0,0,0-.44.1,1,1,0,0,0-.51.76l-1.73,20.3a4.91,4.91,0,0,0,2.52,4.73l18.22,10.08a.93.93,0,0,0,1.39-.75l1.56-21.42a2.8,2.8,0,0,0-1.39-2.62L384,222.5A1,1,0,0,0,383.56,222.38Z",
    style: {
      fill: "#D175F7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.09,107.85a6,6,0,0,1-3-.79L373,92.89a1.39,1.39,0,0,1-.61-.7,16,16,0,0,0-6.19-7.63c-1-.6-3.62-1.79-5,.22a1.42,1.42,0,0,1-1.84.41L337.74,73.05a8,8,0,0,1-4-6.92V50.75a8.74,8.74,0,0,1,5.08-7.93,1.4,1.4,0,0,1,1.29.06l69.46,40.36a1.4,1.4,0,0,1-.14,2.5,3.71,3.71,0,0,0-2.22,3.4v12.62a6,6,0,0,1-3,5.25A6.09,6.09,0,0,1,401.09,107.85ZM374.76,90.68l24.72,13.93a3.27,3.27,0,0,0,4.88-2.85V89.14a6.51,6.51,0,0,1,1.87-4.57L339.33,45.7a6,6,0,0,0-2.82,5V66.13a5.14,5.14,0,0,0,2.61,4.47l20.57,11.59c1.95-1.72,4.9-1.78,7.88-.06A18.44,18.44,0,0,1,374.76,90.68Z",
    style: {
      fill: "#D175F7"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Chair--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M228.11,268.36l-12,73.38a2.29,2.29,0,0,1-2.26,1.92h0a2.29,2.29,0,0,1-2.28-2.54l8.44-75.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.6,243.68l-12,73.38a2.28,2.28,0,0,1-2.25,1.92h0a2.29,2.29,0,0,1-2.28-2.54l8.44-75.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.57,251.2l11.87,63.24a1.93,1.93,0,0,0,3.8-.64l-8.76-58.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.59,227.61l11.8,62.85a1.92,1.92,0,0,0,1.9,1.57,1.94,1.94,0,0,0,1.91-2.21l-8.7-58.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208,222.83A16.86,16.86,0,0,0,218,209.1c1.91-19.25,8.69-58.93,31.68-45.72,28.36,16.3,18.21,63.65,14.08,78.83a20.46,20.46,0,0,1-5.21,9.06c-5.13,5.17-15.74,14.06-33.78,21.62a10.56,10.56,0,0,1-7,.42c-9-2.55-32.38-10.4-44.06-25.33a4.07,4.07,0,0,1,.68-5.7C179.08,238.52,189.76,231,208,222.83Z",
    style: {
      fill: "#D175F7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208,222.83A16.86,16.86,0,0,0,218,209.1c1.91-19.25,8.69-58.93,31.68-45.72,28.36,16.3,18.21,63.65,14.08,78.83a20.46,20.46,0,0,1-5.21,9.06c-5.13,5.17-15.74,14.06-33.78,21.62a10.56,10.56,0,0,1-7,.42c-9-2.55-32.38-10.4-44.06-25.33a4.07,4.07,0,0,1,.68-5.7C179.08,238.52,189.76,231,208,222.83Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.83,245.27a4,4,0,0,0,.84,2.71c.63.8,1.29,1.57,2,2.33h0c.37.41.76.82,1.15,1.22l0,0c.39.4.79.79,1.19,1.17l0,0,1.23,1.14,0,0c.42.38.85.75,1.28,1.12h0c6.62,5.56,14.66,9.79,21.84,12.85h0l1.33.55.14.06,1.22.49.22.09,1.14.45.26.1,1.07.4.3.11c.34.13.66.25,1,.36l.35.13.91.32.38.13.84.29.4.14.76.25.43.14.69.22.46.15.59.18.5.16.49.15.61.18.31.09.86.25a10.56,10.56,0,0,0,7-.42c18-7.56,28.65-16.45,33.78-21.62a20.46,20.46,0,0,0,5.21-9.06c4.13-15.18,14.28-62.53-14.08-78.83-.51-.29-1-.55-1.49-.78a3.18,3.18,0,0,0-.32-.16c-.48-.23-.95-.43-1.41-.61l-.14-.05c-.45-.17-.88-.31-1.32-.44l-.2-.06c-.46-.13-.92-.23-1.37-.32h-.12a12.74,12.74,0,0,0-2.72-.2h0a10.86,10.86,0,0,0-2.57.4h0c4.53-2,10.06-1.91,15.54,1.24,28.37,16.3,18.21,63.64,14.09,78.83l-.7,2.6A24.67,24.67,0,0,1,258,257.06l-7.36,5.63h0a115.82,115.82,0,0,1-25.89,14.74,10.62,10.62,0,0,1-7,.43c-9-2.55-32.39-10.39-44.07-25.33a4,4,0,0,1-.84-2.22h0v-5Z",
    style: {
      fill: "#D175F7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.83,245.27a4,4,0,0,0,.84,2.71c.63.8,1.29,1.57,2,2.33h0c.37.41.76.82,1.15,1.22l0,0c.39.4.79.79,1.19,1.17l0,0,1.23,1.14,0,0c.42.38.85.75,1.28,1.12h0c6.62,5.56,14.66,9.79,21.84,12.85h0l1.33.55.14.06,1.22.49.22.09,1.14.45.26.1,1.07.4.3.11c.34.13.66.25,1,.36l.35.13.91.32.38.13.84.29.4.14.76.25.43.14.69.22.46.15.59.18.5.16.49.15.61.18.31.09.86.25a10.56,10.56,0,0,0,7-.42c18-7.56,28.65-16.45,33.78-21.62a20.46,20.46,0,0,0,5.21-9.06c4.13-15.18,14.28-62.53-14.08-78.83-.51-.29-1-.55-1.49-.78a3.18,3.18,0,0,0-.32-.16c-.48-.23-.95-.43-1.41-.61l-.14-.05c-.45-.17-.88-.31-1.32-.44l-.2-.06c-.46-.13-.92-.23-1.37-.32h-.12a12.74,12.74,0,0,0-2.72-.2h0a10.86,10.86,0,0,0-2.57.4h0c4.53-2,10.06-1.91,15.54,1.24,28.37,16.3,18.21,63.64,14.09,78.83l-.7,2.6A24.67,24.67,0,0,1,258,257.06l-7.36,5.63h0a115.82,115.82,0,0,1-25.89,14.74,10.62,10.62,0,0,1-7,.43c-9-2.55-32.39-10.39-44.07-25.33a4,4,0,0,1-.84-2.22h0v-5Z",
    style: {
      opacity: 0.6000000000000001
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Desk--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M210.12,414.16a5.23,5.23,0,0,0,4.72,0c1.31-.75,1.31-2,0-2.72a5.17,5.17,0,0,0-4.72,0C208.82,412.19,208.82,413.41,210.12,414.16Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 209.14,
    y: 332.37,
    width: 6.68,
    height: 80.36,
    transform: "translate(424.95 745.09) rotate(180)",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286,369.59a5.23,5.23,0,0,0,4.72,0c1.31-.76,1.31-2,0-2.73a5.23,5.23,0,0,0-4.72,0C284.73,367.61,284.73,368.83,286,369.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 285.05,
    y: 287.79,
    width: 6.68,
    height: 80.36,
    transform: "translate(576.78 655.94) rotate(180)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.68,342.06a5.17,5.17,0,0,0,4.72,0c1.31-.75,1.31-2,0-2.72a5.23,5.23,0,0,0-4.72,0C84.38,340.09,84.38,341.31,85.68,342.06Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84.7,
    y: 260.27,
    width: 6.68,
    height: 80.36,
    transform: "translate(176.07 600.9) rotate(180)",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.29,281.25a4.64,4.64,0,0,0,4.23,0,1.29,1.29,0,0,0,0-2.44,4.64,4.64,0,0,0-4.23,0A1.29,1.29,0,0,0,167.29,281.25Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 166.41,
    y: 212.9,
    width: 5.99,
    height: 67.06,
    transform: "translate(338.8 492.87) rotate(180)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "291.73 274.48 291.73 290.47 212.47 336.23 212.47 320.24 291.73 274.48",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "84.7 246.47 212.47 320.24 212.47 336.23 84.7 262.46 84.7 246.47",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "163.96 200.71 291.73 274.48 212.47 320.24 84.7 246.47 163.96 200.71",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.36,279.79l-58.77-33.93a.93.93,0,0,1,0-1.61l11.31-6.53a1,1,0,0,1,.93,0l58.77,33.93a.93.93,0,0,1,0,1.6l-11.32,6.54A.94.94,0,0,1,164.36,279.79Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.63,306.5l-34.28-20a.51.51,0,0,1,0-.88l38-23.42Z",
    style: {
      fill: "#D175F7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.63,306.5l-34.28-20a.51.51,0,0,1,0-.88l38-23.42Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "220.63 306.5 258.85 284.37 258.85 274.31 220.63 296.35 220.63 306.5",
    style: {
      fill: "#D175F7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "220.63 306.5 258.85 284.37 258.85 274.31 220.63 296.35 220.63 306.5",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.39,285.92l-15.09,8.71c-1,.58-1.82,0-1.82-1.37h0a4.36,4.36,0,0,1,1.82-3.47l15.09-8.72c1-.58,1.82,0,1.82,1.38h0A4.33,4.33,0,0,1,251.39,285.92Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.27,294.54a4.61,4.61,0,0,1-2.1,3.63c-1.16.67-2.1.13-2.1-1.21a4.63,4.63,0,0,1,2.1-3.63C231.33,292.66,232.27,293.2,232.27,294.54Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.63,296.35,186.49,280.3a.52.52,0,0,1-.05-.91l36.63-21.78a1.42,1.42,0,0,1,1.37-.05l34.41,16.75Z",
    style: {
      fill: "#D175F7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "188.69 281.33 188.69 285.65 216.97 301.65 216.97 294.63 188.69 281.33",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "216.97 301.65 220.63 299.36 220.63 296.35 216.97 294.63 216.97 301.65",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.19,276.14V265h62.33c.21,0,6.9,3.49,9.86,5a.85.85,0,0,1,0,1.49L221.47,292.4a1.88,1.88,0,0,1-1.71.05Z",
    style: {
      fill: "#D175F7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.19,276.14V265h62.33c.21,0,6.9,3.49,9.86,5a.85.85,0,0,1,0,1.49L221.47,292.4a1.88,1.88,0,0,1-1.71.05Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "220.63 289.76 255.99 269.88 255.99 265.56 220.63 284.37 220.63 289.76",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "186.19 276.14 195.44 270.73 186.19 264.98 186.19 276.14",
    style: {
      fill: "#D175F7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "186.19 276.14 195.44 270.73 186.19 264.98 186.19 276.14",
    style: {
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "192.03 268.61 192.03 274.77 220.63 289.76 220.63 284.37 192.03 268.61",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.19,265l33.25,19.82a2.48,2.48,0,0,0,2.42.07l36.65-19.2a.85.85,0,0,0,.06-1.46l-33.46-21.75Z",
    style: {
      fill: "#D175F7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "200 241.6 200 243.9 185.28 252.21 185.28 249.91 200 241.6",
    style: {
      fill: "#D175F7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "200 241.6 200 243.9 185.28 252.21 185.28 249.91 200 241.6",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "151.69 230.5 185.28 249.91 185.28 252.21 151.69 232.8 151.69 230.5",
    style: {
      fill: "#D175F7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "151.69 230.5 185.28 249.91 185.28 252.21 151.69 232.8 151.69 230.5",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "166.41 222.19 200 241.6 185.28 249.91 151.69 230.5 166.41 222.19",
    style: {
      fill: "#D175F7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "166.41 222.19 200 241.6 185.28 249.91 151.69 230.5 166.41 222.19",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.05,263.22l1.5.87v2.74a5.31,5.31,0,0,0,2.75-.75l.11-.07a3,3,0,0,0,1.38-1.89,1.72,1.72,0,0,0,.08-.52v-3.74Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.7,162.19l.12-.07a5.41,5.41,0,0,1,2.75-.75h0a1.65,1.65,0,0,1,.87.23l64.81,37.26a5.25,5.25,0,0,1,2.62,4.54v56.46l-5.82,3.36-61.56-35.39a5.25,5.25,0,0,1-2.62-4.54V164.75h-2.62A3,3,0,0,1,107.7,162.19Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.31,201.05a5.25,5.25,0,0,1,.56,2.35v56.46l-5.82,3.36L170.87,262v-56.3Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.25,261.37v3.75a1.72,1.72,0,0,1-2.58,1.48l-64.8-37.26a5.25,5.25,0,0,1-2.62-4.54V221Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.25,164.6a1.72,1.72,0,0,1,2.58-1.49l64.8,37.27a5.23,5.23,0,0,1,2.62,4.54v56.45l-70-40.41",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "143.56 230.49 131.21 224.25 134.23 222.19 146.12 228.44 143.56 230.49",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.21,224.24l-7.14,28.38a2.06,2.06,0,0,0,1,2.3l14.76,8.3s4.59-32.3,3.74-32.73Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "147.6 256.87 142.52 253.79 141.54 260.68 147.6 256.87",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.56,230.49,139,261.67a1.47,1.47,0,0,0,2.29,1.43l5.86-4a1.55,1.55,0,0,0,.69-1.29v-.6a.45.45,0,0,0-.71-.37l-5.56,3.81,4.58-32.23Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.24,214.6c0,2.73-1.92,3.84-4.29,2.47a9.49,9.49,0,0,1-4.28-7.42c0-2.73,1.92-3.84,4.28-2.47A9.47,9.47,0,0,1,143.24,214.6Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Files--inject-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "94.94 369.42 134.21 346.93 103.03 329.74 65.13 352.05 94.94 369.42",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.3,365.67a.41.41,0,0,1-.18-.05l-22.8-13.29a.35.35,0,1,1,.35-.6L96.47,365a.35.35,0,0,1,.13.48A.35.35,0,0,1,96.3,365.67Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100,363.4a.34.34,0,0,1-.17,0L77.06,350.06a.34.34,0,0,1-.12-.47.34.34,0,0,1,.47-.13l22.81,13.29a.35.35,0,0,1,.12.48A.34.34,0,0,1,100,363.4Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.68,361.23a.33.33,0,0,1-.17,0L80.7,347.9a.35.35,0,0,1-.12-.48.34.34,0,0,1,.47-.13l22.81,13.3a.34.34,0,0,1-.18.64Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.43,359a.41.41,0,0,1-.18-.05l-22.8-13.29a.36.36,0,0,1-.13-.48.34.34,0,0,1,.48-.12l22.8,13.29a.34.34,0,0,1,.13.47A.35.35,0,0,1,107.43,359Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.17,356.7a.34.34,0,0,1-.17-.05L88.19,343.36a.35.35,0,0,1-.12-.48.33.33,0,0,1,.47-.12l22.81,13.29a.34.34,0,0,1,.12.47A.35.35,0,0,1,111.17,356.7Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.92,354.43a.41.41,0,0,1-.18-.05l-22.8-13.29a.35.35,0,1,1,.35-.6l22.8,13.29a.34.34,0,0,1,.13.47A.36.36,0,0,1,114.92,354.43Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.66,352.16a.34.34,0,0,1-.17-.05L95.68,338.82a.35.35,0,0,1-.12-.48.34.34,0,0,1,.47-.12l22.81,13.29a.34.34,0,0,1,.12.47A.33.33,0,0,1,118.66,352.16Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.41,349.89a.41.41,0,0,1-.18-.05l-22.8-13.29a.35.35,0,1,1,.35-.6l22.8,13.29a.35.35,0,0,1,.13.48A.35.35,0,0,1,122.41,349.89Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.15,347.62a.34.34,0,0,1-.17-.05l-22.81-13.29a.35.35,0,0,1-.12-.48.34.34,0,0,1,.47-.12L126.33,347a.35.35,0,0,1,.12.48A.34.34,0,0,1,126.15,347.62Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "65.25 351.94 95.05 369.31 95.05 396.01 65.25 379.55 65.25 351.94",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "95.05 369.31 134.32 346.82 134.32 373.21 95.05 396.01 95.05 369.31",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "88.64 371.92 95.05 375.66 108.92 367.72 95.05 377.69 88.64 371.92",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "88.64 381.21 95.05 384.95 102.89 380.47 95.05 386.98 88.64 381.21",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "98.78 376.91 103.68 378.37 107.43 372.7 98.78 376.91",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "98.78 376.91 113.57 368.49 106.18 376.91 98.78 376.91",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "120.92 358.81 124.39 359.85 127.04 355.83 120.92 358.81",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "120.92 358.81 131.39 352.85 126.15 358.81 120.92 358.81",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "113.43 378.66 116.9 379.7 119.55 375.68 113.43 378.66",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "113.43 378.66 123.9 372.7 118.66 378.66 113.43 378.66",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.73,430.78l-34.28-20a.51.51,0,0,1,0-.88l38-23.42Z",
    style: {
      fill: "#D175F7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.73,430.78l-34.28-20a.51.51,0,0,1,0-.88l38-23.42Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "155.73 430.78 193.95 408.65 193.95 398.59 155.73 420.63 155.73 430.78",
    style: {
      fill: "#D175F7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "155.73 430.78 193.95 408.65 193.95 398.59 155.73 420.63 155.73 430.78",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.49,410.2l-15.09,8.72c-1,.58-1.82,0-1.82-1.38h0a4.33,4.33,0,0,1,1.82-3.47l15.09-8.71c1-.58,1.82,0,1.82,1.37h0A4.36,4.36,0,0,1,186.49,410.2Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.36,418.82a4.65,4.65,0,0,1-2.1,3.64c-1.15.67-2.09.12-2.09-1.21a4.66,4.66,0,0,1,2.09-3.64C166.42,416.94,167.36,417.48,167.36,418.82Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.73,420.63l-34.15-16.05a.51.51,0,0,1,0-.9l36.62-21.78a1.44,1.44,0,0,1,1.38-.06L194,398.59Z",
    style: {
      fill: "#D175F7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "123.78 405.62 123.78 409.93 152.07 425.93 152.07 418.91 123.78 405.62",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "152.07 425.93 155.73 423.65 155.73 420.63 152.07 418.91 152.07 425.93",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.29,400.42V389.27h62.32c.22,0,6.91,3.48,9.87,5a.86.86,0,0,1,0,1.5l-36.93,20.88a1.82,1.82,0,0,1-1.71.05Z",
    style: {
      fill: "#D175F7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.29,400.42V389.27h62.32c.22,0,6.91,3.48,9.87,5a.86.86,0,0,1,0,1.5l-36.93,20.88a1.82,1.82,0,0,1-1.71.05Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "155.73 414.05 191.09 394.16 191.09 389.84 155.73 408.65 155.73 414.05",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "121.29 400.42 130.54 395.01 121.29 389.27 121.29 400.42",
    style: {
      fill: "#D175F7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "121.29 400.42 130.54 395.01 121.29 389.27 121.29 400.42",
    style: {
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "127.13 392.89 127.13 399.05 155.73 414.05 155.73 408.65 127.13 392.89",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.29,389.27l33.25,19.81a2.44,2.44,0,0,0,2.41.07L193.61,390a.85.85,0,0,0,0-1.46l-33.45-21.74Z",
    style: {
      fill: "#D175F7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.73,405.62l-34.28-20a.51.51,0,0,1,0-.88l38-23.42Z",
    style: {
      fill: "#D175F7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.73,405.62l-34.28-20a.51.51,0,0,1,0-.88l38-23.42Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "155.73 405.62 193.95 383.49 193.95 373.43 155.73 395.47 155.73 405.62",
    style: {
      fill: "#D175F7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "155.73 405.62 193.95 383.49 193.95 373.43 155.73 395.47 155.73 405.62",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.49,385l-15.09,8.71c-1,.58-1.82,0-1.82-1.37h0a4.33,4.33,0,0,1,1.82-3.47l15.09-8.72c1-.58,1.82,0,1.82,1.38h0A4.36,4.36,0,0,1,186.49,385Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.36,393.66a4.61,4.61,0,0,1-2.1,3.63c-1.15.67-2.09.13-2.09-1.21a4.64,4.64,0,0,1,2.09-3.63C166.42,391.78,167.36,392.32,167.36,393.66Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.73,395.47l-34.15-16.05a.52.52,0,0,1,0-.91l36.62-21.78a1.44,1.44,0,0,1,1.38-.05L194,373.43Z",
    style: {
      fill: "#D175F7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "123.78 380.45 123.78 384.77 152.07 400.77 152.07 393.75 123.78 380.45",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "152.07 400.77 155.73 398.48 155.73 395.47 152.07 393.75 152.07 400.77",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.34,374.53V363.37h62.32c.21,0,6.9,3.49,9.86,5a.85.85,0,0,1,0,1.49l-36.94,20.89a1.86,1.86,0,0,1-1.7,0Z",
    style: {
      fill: "#D175F7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.34,374.53V363.37h62.32c.21,0,6.9,3.49,9.86,5a.85.85,0,0,1,0,1.49l-36.94,20.89a1.86,1.86,0,0,1-1.7,0Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "155.77 388.15 191.14 368.26 191.14 363.94 155.77 382.76 155.77 388.15",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "121.34 374.53 130.58 369.12 121.34 363.37 121.34 374.53",
    style: {
      fill: "#D175F7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "121.34 374.53 130.58 369.12 121.34 363.37 121.34 374.53",
    style: {
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "127.17 367 127.17 373.16 155.77 388.15 155.77 382.76 127.17 367",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.34,363.37l33.25,19.82a2.46,2.46,0,0,0,2.41.07l36.66-19.2a.85.85,0,0,0,.05-1.46l-33.46-21.75Z",
    style: {
      fill: "#D175F7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.77,379.72l-34.27-20a.51.51,0,0,1,0-.88l38-23.41Z",
    style: {
      fill: "#D175F7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.77,379.72l-34.27-20a.51.51,0,0,1,0-.88l38-23.41Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "155.77 379.72 193.99 357.59 193.99 347.54 155.77 369.57 155.77 379.72",
    style: {
      fill: "#D175F7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "155.77 379.72 193.99 357.59 193.99 347.54 155.77 369.57 155.77 379.72",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.54,359.15l-15.1,8.71c-1,.58-1.81,0-1.81-1.37h0a4.37,4.37,0,0,1,1.81-3.48l15.1-8.71c1-.58,1.81,0,1.81,1.37h0A4.37,4.37,0,0,1,186.54,359.15Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.41,367.77a4.64,4.64,0,0,1-2.1,3.63c-1.16.67-2.1.13-2.1-1.21a4.65,4.65,0,0,1,2.1-3.64C166.47,365.89,167.41,366.43,167.41,367.77Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.77,369.57l-34.14-16a.52.52,0,0,1,0-.91l36.62-21.78a1.47,1.47,0,0,1,1.38-.06L194,347.54Z",
    style: {
      fill: "#D175F7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "123.83 354.56 123.83 358.87 152.12 374.88 152.12 367.85 123.83 354.56",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "152.12 374.88 155.77 372.59 155.77 369.57 152.12 367.85 152.12 374.88",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "154.82 340.59 194.09 318.1 162.9 300.91 125.01 323.22 154.82 340.59",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.17,336.83a.35.35,0,0,1-.17,0L133.2,323.5a.35.35,0,0,1-.13-.48.34.34,0,0,1,.47-.12l22.81,13.29a.34.34,0,0,1,.13.47A.37.37,0,0,1,156.17,336.83Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.92,334.56a.33.33,0,0,1-.17,0l-22.81-13.29a.36.36,0,0,1-.13-.48.34.34,0,0,1,.48-.12l22.8,13.29a.34.34,0,0,1-.17.64Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.56,332.4a.34.34,0,0,1-.17,0l-22.81-13.29a.35.35,0,0,1-.12-.48.34.34,0,0,1,.47-.12l22.81,13.29a.35.35,0,0,1,.12.48A.34.34,0,0,1,163.56,332.4Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.31,330.13a.41.41,0,0,1-.18-.05l-22.8-13.29a.34.34,0,0,1-.13-.47.35.35,0,0,1,.48-.13l22.8,13.29a.36.36,0,0,1,.13.48A.36.36,0,0,1,167.31,330.13Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.05,327.86a.26.26,0,0,1-.17-.05l-22.81-13.29a.34.34,0,0,1-.12-.47.34.34,0,0,1,.47-.13l22.81,13.29a.35.35,0,0,1,.12.48A.34.34,0,0,1,171.05,327.86Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.79,325.59a.28.28,0,0,1-.17,0l-22.8-13.29a.34.34,0,0,1-.13-.47.36.36,0,0,1,.48-.13L175,324.94a.36.36,0,0,1,.13.48A.37.37,0,0,1,174.79,325.59Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.54,323.32a.26.26,0,0,1-.17-.05L155.56,310a.34.34,0,0,1-.13-.47.36.36,0,0,1,.48-.13l22.8,13.29a.35.35,0,0,1,.13.48A.34.34,0,0,1,178.54,323.32Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.29,321.05a.39.39,0,0,1-.18,0l-22.8-13.3a.34.34,0,0,1-.13-.47.36.36,0,0,1,.48-.13l22.8,13.29a.36.36,0,0,1,.13.48A.36.36,0,0,1,182.29,321.05Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186,318.78a.39.39,0,0,1-.18,0l-22.8-13.29a.35.35,0,1,1,.35-.61l22.8,13.29a.35.35,0,0,1,.13.48A.34.34,0,0,1,186,318.78Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "125.12 323.1 154.93 340.48 154.93 367.18 125.12 350.72 125.12 323.1",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "154.93 340.48 194.2 317.98 194.2 344.38 154.93 367.18 154.93 340.48",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "148.52 343.09 154.93 346.82 168.8 338.88 154.93 348.85 148.52 343.09",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "148.52 352.38 154.93 356.12 162.76 351.63 154.93 358.15 148.52 352.38",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "158.66 348.08 163.56 349.54 167.31 343.87 158.66 348.08",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "158.66 348.08 173.45 339.65 166.05 348.08 158.66 348.08",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "180.79 329.98 184.26 331.01 186.91 327 180.79 329.98",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "180.79 329.98 191.26 324.01 186.03 329.98 180.79 329.98",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "173.31 349.83 176.78 350.86 179.43 346.85 173.31 349.83",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "173.31 349.83 183.78 343.87 178.54 349.83 173.31 349.83",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "135.82 350.66 133.28 351.42 131.33 348.47 135.82 350.66",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "135.82 350.66 128.14 346.28 131.98 350.66 135.82 350.66",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "145.82 340.18 142.35 341.21 139.7 337.2 145.82 340.18",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "145.82 340.18 135.35 334.22 140.59 340.18 145.82 340.18",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "389.97 394.31 386.64 392.92 387.5 388.88 389.97 394.31",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "393.72 383.44 395.14 389.79 389.97 394.31 387.5 388.88 393.72 383.44",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.46,376.85a39.7,39.7,0,0,0-2.1,8.14,20.49,20.49,0,0,1-5.26,10.51c-2.43,2.24-6.77,7.4.76,8.32,7.79,1,14.32-5.48,14.42-9.05s1.05-6.37,3-8,3.47-3.3,3.47-3.3-3.47-12.46-6.44-11.76S379.46,376.85,379.46,376.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.47,364.66c-2.24-3.38-4.77-7.36-6.81-11-4.8-8.64-12.07-22.36-19.2-25.1V270.31l-27.38-1.26s-9,31.91,3.79,57.56c9.14,18.37,29,37.52,39.49,46.9C375.64,373,381.64,371.11,382.47,364.66Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388,372.69s-2.5-3.45-5.54-8c-.83,6.45-6.83,8.31-10.11,8.85,4.16,3.71,6.87,5.9,6.87,5.9S388.14,380.65,388,372.69Z",
    style: {
      fill: "#945959"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.84,324.36l7.34-36.22s-5.48-3.2-5.48-11.66c0,0-.69,8.16,3,14.06l-6.31,30.28C330.83,322,331.32,323.19,331.84,324.36Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.46,328.53v-2.1L353,328.67l-6.38,9.87-.6,7.75c2.51,3.09,5.13,6.09,7.74,8.93l.52-12.7,4.8-12.54A11.42,11.42,0,0,0,356.46,328.53Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "331.27 424.67 327.89 422.75 331.27 418.27 331.27 424.67",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "336.19 416.08 336.19 421.75 331.27 424.67 331.27 418.27 336.19 416.08",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.51,404.06s-1.92-.78-3.75,5.89-9.41,11-11.33,12.16-7,6,0,8.5,15.91-1.18,18-5.39,3.16-6.77,7.75-9.14v-8.51c0-1.64-1.72-2.83-2.81-3.11S325.51,404.06,325.51,404.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.55,269.05l-30.85-2.17v9.6c0,8.46,5.48,11.66,5.48,11.66l-9.33,46a52.44,52.44,0,0,0-.92,6.72l-4.05,57.72a11.72,11.72,0,0,0,11.31,2.3c2.1-6.43,5.68-17.17,9.9-28.91,5.08-14.17,5.31-24,5.11-28a9.09,9.09,0,0,1,.73-4.09c1.68-3.9,5.77-13.38,12.62-29.37C377.31,280.81,364.55,269.05,364.55,269.05Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.88,398.62l-.58,8.29a5.45,5.45,0,0,0,5,2.58c3.66,0,4.94-2.37,4.94-2.37s.73-2.31,2-6.2A11.72,11.72,0,0,1,324.88,398.62Z",
    style: {
      fill: "#945959"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.77,224.62s-8.62.33-11.63,6.65-7.31,19.09-7.31,19.09l11.56,2.6Z",
    style: {
      fill: "#D175F7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.77,224.62s-8.62.33-11.63,6.65-7.31,19.09-7.31,19.09l11.56,2.6Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.2,225.92l9.35,1.62v21l-2.92,11.16s.55,6,2.92,9.32c0,0-16.64,12.62-35.47,0,0,0,.73-11,.73-14.08,0,0-6.38-3.84-5.75-9.69s12.71-20.66,12.71-20.66l6.64-.09Z",
    style: {
      fill: "#D175F7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.2,225.92l9.35,1.62v21l-2.92,11.16s.55,6,2.92,9.32c0,0-16.64,12.62-35.47,0,0,0,.73-11,.73-14.08,0,0-6.38-3.84-5.75-9.69s12.71-20.66,12.71-20.66l6.64-.09Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.13,183s-8.08-2.8-10.05,5.47,4.11,16.29-5,19c0,0,5.37,4.47,10.09-3.87l4,17s0,.93-1.41,1.64c0,0,23,5.1,27.35-6.35a4.88,4.88,0,0,1,1,5s6.77-2.74,4.87-11.51c0,0,5.35-.15,6.62-4.51,0,0-8.56.41-8.51-9,.06-10.92-5.69-9.34-5.69-9.34S355.37,176.06,339.13,183Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.41,217.24v7.29s-6.55,11.29-4,12c4.88,1.37,15.74-10.63,15.74-10.63V210.5Z",
    style: {
      fill: "#945959"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.07,208.06v.43c-2.63,10.36-9.46,12.62-11.66,13.15l-.08-16,11.4-.05Z",
    style: {
      fill: "#703838"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.15,185c-4.35.36-13.4,3.54-13.54,15s1.62,20.23,7.57,20.59,19.25-5,19.86-19.9S348.4,184.63,344.15,185Z",
    style: {
      fill: "#945959"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "338.65 204.61 338.75 211.35 334.79 210.2 338.65 204.61",
    style: {
      fill: "#703838"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.57,204.43a1.38,1.38,0,0,1-2.75,0,1.39,1.39,0,0,1,1.36-1.4A1.37,1.37,0,0,1,344.57,204.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.53,203.6a1.38,1.38,0,1,1-1.4-1.36A1.37,1.37,0,0,1,335.53,203.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.44,200.78l2.66-1.63s-1-1.06-2.06-.4A1.87,1.87,0,0,0,332.44,200.78Z",
    style: {
      fill: "#D175F7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.44,200.78l2.66-1.63s-1-1.06-2.06-.4A1.87,1.87,0,0,0,332.44,200.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.33,203.81s-.27,4.83,2.51,4.83h5.45v-9.21c0-10.33-7.83-21.12-24.5-12.59C334.79,186.84,334,200.63,351.33,203.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.82,208.07a6.93,6.93,0,0,1,.6-3,3.24,3.24,0,0,1,2.83-2.18c3.25-.05,3.65,3.08,3.6,4.19-.15,2.92-2.54,6.05-7,6.12Z",
    style: {
      fill: "#945959"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.26,213.48a1.13,1.13,0,1,1-1.13-1.13A1.13,1.13,0,0,1,342.26,213.48Z",
    style: {
      fill: "#703838"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.55,227.54s-7.68,2.79-4.32,16.23,6.59,24.69,6.59,24.69l-13.37,8s4.86,2.33,3.77,10.9c0,0,17.48-4.32,21.53-7.26s2.67-11.53,1.71-16.26-5.48-23.93-6.17-26.54S371.56,228.76,364.55,227.54Z",
    style: {
      fill: "#D175F7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.55,227.54s-7.68,2.79-4.32,16.23,6.59,24.69,6.59,24.69l-13.37,8s4.86,2.33,3.77,10.9c0,0,17.48-4.32,21.53-7.26s2.67-11.53,1.71-16.26-5.48-23.93-6.17-26.54S371.56,228.76,364.55,227.54Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.82,268.46a12.16,12.16,0,0,1,7.54,1.85,10.79,10.79,0,0,0-8.12-3.88Z",
    style: {
      fill: "#D175F7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.71,300.69l-34.28-20a.51.51,0,0,1,0-.88l38-23.42Z",
    style: {
      fill: "#D175F7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.71,300.69l-34.28-20a.51.51,0,0,1,0-.88l38-23.42Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "311.71 300.69 349.93 278.56 349.93 268.5 311.71 290.54 311.71 300.69",
    style: {
      fill: "#D175F7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "311.71 300.69 349.93 278.56 349.93 268.5 311.71 290.54 311.71 300.69",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.47,280.11l-15.09,8.72c-1,.58-1.82,0-1.82-1.38h0a4.33,4.33,0,0,1,1.82-3.47l15.09-8.71c1-.58,1.82,0,1.82,1.37h0A4.36,4.36,0,0,1,342.47,280.11Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.34,288.73a4.65,4.65,0,0,1-2.1,3.64c-1.16.67-2.09.12-2.09-1.21a4.64,4.64,0,0,1,2.09-3.64C322.4,286.85,323.34,287.39,323.34,288.73Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.71,290.54l-34.15-16.05a.51.51,0,0,1,0-.9l36.62-21.78a1.44,1.44,0,0,1,1.38-.06l34.41,16.75Z",
    style: {
      fill: "#D175F7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "279.76 275.52 279.76 279.84 308.05 295.84 308.05 288.82 279.76 275.52",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "308.05 295.84 311.71 293.56 311.71 290.54 308.05 288.82 308.05 295.84",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.22,287.38s-15,3.23-16.39,3.57-8.64,2.61-14.61,1.3l14.74-8.5s-7.52-1.84-6.44-4.18c.41-.89,14.4-.41,14.4-.41l4.53-2.68S361.47,277.51,357.22,287.38Z",
    style: {
      fill: "#945959"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.27,270.33V259.18h62.32c.22,0,6.91,3.48,9.87,5a.86.86,0,0,1,0,1.5l-36.93,20.88a1.82,1.82,0,0,1-1.71.05Z",
    style: {
      fill: "#D175F7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.27,270.33V259.18h62.32c.22,0,6.91,3.48,9.87,5a.86.86,0,0,1,0,1.5l-36.93,20.88a1.82,1.82,0,0,1-1.71.05Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "311.71 283.95 347.07 264.07 347.07 259.75 311.71 278.56 311.71 283.95",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "277.27 270.33 286.51 264.92 277.27 259.18 277.27 270.33",
    style: {
      fill: "#D175F7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "277.27 270.33 286.51 264.92 277.27 259.18 277.27 270.33",
    style: {
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "283.11 262.8 283.11 268.96 311.71 283.95 311.71 278.56 283.11 262.8",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.27,259.18,310.52,279a2.44,2.44,0,0,0,2.41.07l36.66-19.2a.85.85,0,0,0,.05-1.46l-33.45-21.74Z",
    style: {
      fill: "#D175F7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.71,275.53l-34.28-20a.51.51,0,0,1,0-.88l38-23.42Z",
    style: {
      fill: "#D175F7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.71,275.53l-34.28-20a.51.51,0,0,1,0-.88l38-23.42Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "311.71 275.52 349.93 253.4 349.93 243.34 311.71 265.38 311.71 275.52",
    style: {
      fill: "#D175F7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "311.71 275.52 349.93 253.4 349.93 243.34 311.71 265.38 311.71 275.52",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.47,255l-15.09,8.71c-1,.58-1.82,0-1.82-1.37h0a4.33,4.33,0,0,1,1.82-3.47l15.09-8.72c1-.57,1.82,0,1.82,1.38h0A4.36,4.36,0,0,1,342.47,255Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.34,263.57a4.61,4.61,0,0,1-2.1,3.63c-1.16.67-2.09.13-2.09-1.21a4.63,4.63,0,0,1,2.09-3.63C322.4,261.69,323.34,262.23,323.34,263.57Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.71,265.38l-34.15-16a.52.52,0,0,1,0-.91l36.62-21.78a1.44,1.44,0,0,1,1.38,0l34.41,16.75Z",
    style: {
      fill: "#D175F7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "279.76 250.36 279.76 254.68 308.05 270.68 308.05 263.66 279.76 250.36",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "308.05 270.68 311.71 268.39 311.71 265.38 308.05 263.66 308.05 270.68",
    style: {
      fill: "#e0e0e0"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgC12);
export default __webpack_public_path__ + "static/media/c12.9fbaca8903ce71b1ea2808c38536caef.svg";
export { ForwardRef as ReactComponent };